import Turbolinks from "turbolinks"
import "../controllers"

Turbolinks.start()
import "../stylesheets/application.css"
import "@khmyznikov/pwa-install"
import posthog from "posthog-js"
import { initPullToRefresh } from "../pull_to_refresh"
import { initSubmitSpinner } from "../submit_spinner"

initPullToRefresh()
initSubmitSpinner()

// Initialize PostHog
const posthogApiKey = document.querySelector(
  'meta[name="posthog-api-key"]'
)?.content
const posthogHost = document.querySelector('meta[name="posthog-host"]')?.content
const posthogDistinctId = document.querySelector(
  'meta[name="posthog-distinct-id"]'
)?.content

if (posthogApiKey) {
  posthog.init(posthogApiKey, {
    api_host: posthogHost,
    capture_pageview: true,
    capture_pageleave: true
  })

  if (posthogDistinctId) {
    posthog.identify(posthogDistinctId)
  }
}

// Register service worker for PWA
if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((registration) => {
        console.log("ServiceWorker registered:", registration.scope)

        // Check for updates on page load
        registration.update()
      })
      .catch((error) => {
        console.log("ServiceWorker registration failed:", error)
      })
  })
}

// Initialize PWA install prompt
document.addEventListener("DOMContentLoaded", () => {
  const pwaInstall = document.createElement("pwa-install")

  pwaInstall.setAttribute("manifest-url", "/manifest.json")
  pwaInstall.setAttribute("icon", "/icon-192.png")
  pwaInstall.setAttribute("name", "Stonksfolio")
  pwaInstall.setAttribute(
    "description",
    "Track and analyze your investment portfolio"
  )

  pwaInstall.setAttribute(
    "install-description",
    "Install Stonksfolio on your device for quick access and offline support."
  )

  pwaInstall.setAttribute(
    "ios-install-description",
    'Tap the Share button below, then select "Add to Home Screen" to install Stonksfolio.'
  )

  // Add to DOM
  document.body.appendChild(pwaInstall)
})
